<dialog-header
  [title]="'Voucher'"
  (onClose)="matDialogRef.close()"
></dialog-header>

<div mat-dialog-content>
  <div *ngIf="!voucherDetails">
    <div class="form-field">
      <div class="form-field-label">
        Voucher Code<span style="color: red">*</span>
      </div>
      <mat-form-field class="full-width">
        <input
          type="text"
          matInput
          [formControl]="codeFormControl"
          [matAutocomplete]="auto"
          placeholder="Enter voucher code"
          (input)="onInputChange($event)"
          [ngStyle]="{
            border:
              codeFormControl.invalid && submitted
                ? '1px solid red'
                : '1px solid var(--app-light-grey)',
          }"
        />
        <mat-autocomplete
          #auto="matAutocomplete"
          (optionSelected)="onOptionSelected($event.option.value)"
        >
          <mat-option
            *ngFor="let voucher of filteredVouchers | async"
            [value]="voucher"
          >
            <div class="autocomplete-option">
              <span class="voucher-code">{{ voucher.code }}</span>
              <span class="voucher-value">{{
                voucher.value | currency: "GBP"
              }}</span>
              <span
                class="voucher-status"
                [ngClass]="{
                  'status-redeemed': voucher.status === 'redeemed',
                  'status-expired':
                    voucher.status === 'expired' ||
                    voucher.status == 'cancelled',
                  'status-pending': voucher.status === 'pending',
                  'status-valid': validStatus,
                }"
              >
                {{ statusLabel(voucher) }}
              </span>
            </div>
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div>
  </div>

  <div *ngIf="voucherDetails">
    <mat-tab-group
      mat-align-tabs="start"
      mat-stretch-tabs="false"
      disableRipple="true"
      [animationDuration]="0"
      (selectedTabChange)="onTabChange($event)"
    >
      <mat-tab label="Details">
        <div class="voucher-details-container">
          <div class="voucher-card">
            <div
              class="status-badge"
              [ngClass]="constants.statusChipClass(voucherDetails)"
            >
              {{ getVoucherStatus() }}
            </div>
            <div class="voucher-header">
              <h3>
                {{
                  (voucherDetails?.voucher?.[0] ?? voucherDetails.voucher)
                    ?.displayAs
                }}
              </h3>
            </div>

            <div class="voucher-value-section">
              <div class="value-box">
                <div style="display: flex; justify-content: space-between">
                  <div style="display: flex; flex-direction: column">
                    <span class="value-label">Redeemable Value</span>
                    <span class="value-amount">{{
                      voucherDetails.value | currency: "GBP"
                    }}</span>
                  </div>

                  <div style="display: flex; flex-direction: column">
                    <span class="value-label">Remaining</span>
                    <span class="value-amount">{{
                      voucherDetails?.remainingValue ?? voucherDetails?.value
                        | currency: "GBP"
                    }}</span>
                  </div>
                </div>
              </div>
              <div class="value-box">
                <span class="value-label">Cost to Customer</span>
                <span class="value-amount">{{
                  voucherDetails?.cost | currency: "GBP"
                }}</span>
              </div>
            </div>

            <div
              class="redemption-options"
              *ngIf="voucherDetails?.allowPartialRedemption && validStatus"
              style="margin-bottom: 20px"
            >
              <mat-radio-group
                [(ngModel)]="isPartialRedemption"
                (change)="onPartialRedemptionChange()"
              >
                <div class="radio-option">
                  <label class="radio-option-label">
                    <mat-radio-button [value]="false">
                      Full Redemption
                    </mat-radio-button>
                    <div class="radio-description">
                      Redeem the full remaining value of
                      {{
                        voucherDetails.remainingValue ?? voucherDetails.value
                          | currency: "GBP"
                      }}. No change will be given.
                    </div>
                  </label>
                </div>

                <div class="radio-option">
                  <label class="radio-option-label">
                    <mat-radio-button [value]="true">
                      Partial Redemption
                    </mat-radio-button>
                    <div class="radio-description">
                      Redeem a partial amount and keep the remaining balance for
                      later use
                    </div>
                  </label>
                </div>
              </mat-radio-group>

              <div *ngIf="isPartialRedemption" class="partial-redemption-input">
                <div class="form-field">
                  <div class="form-field-label">Redemption Amount</div>
                  <input
                    type="number"
                    class="form-input"
                    [formControl]="redemptionAmountControl"
                    [max]="maxRedemptionAmount"
                    [min]="0"
                    placeholder="Enter amount to redeem"
                    (input)="onRedemptionAmountChange()"
                  />
                </div>
                <div
                  class="remaining-balance"
                  *ngIf="redemptionAmountControl.valid"
                >
                  Remaining balance will be:
                  {{ getRemainingBalance() | currency: "GBP" }}
                </div>
              </div>
            </div>

            <div class="voucher-info">
              <div class="info-row">
                <mat-icon fontSet="material-icons-outlined">redeem</mat-icon>
                <div class="info-content">
                  <span class="info-label">Voucher Code</span>
                  <span class="info-value">{{ voucherDetails.code }}</span>
                </div>
              </div>

              <div class="info-row">
                <mat-icon fontSet="material-icons-outlined">receipt</mat-icon>
                <div class="info-content">
                  <span class="info-label">Order Reference</span>
                  <span class="info-value">{{ voucherDetails?.orderRef }}</span>
                </div>
              </div>

              <!-- Purchaser Information -->
              <div class="info-row">
                <mat-icon fontSet="material-icons-outlined">person</mat-icon>
                <div class="info-content">
                  <span class="info-label">Purchased By</span>

                  <a
                    *ngIf="voucherDetails?.customer?.nanoid"
                    [routerLink]="[
                      '/customer',
                      voucherDetails?.customer?.nanoid,
                    ]"
                    (click)="$event.stopPropagation(); matDialogRef.close()"
                  >
                    {{ voucherDetails?.customer?.name }}
                  </a>

                  <span
                    class="info-value"
                    *ngIf="!voucherDetails?.customer?.nanoid"
                    >{{ getPurchaserName() }}</span
                  >
                </div>
              </div>

              <div
                class="info-row"
                *ngIf="
                  voucherDetails?.source == 'merchant_issued' &&
                  voucherDetails?.user?.name
                "
              >
                <mat-icon fontSet="material-icons-outlined">person</mat-icon>
                <div class="info-content">
                  <span class="info-label">Issued To</span>
                  <span class="info-value">{{
                    voucherDetails?.user?.name
                  }}</span>
                </div>
              </div>

              <div class="info-row" *ngIf="voucherDetails?.purchaser?.email">
                <mat-icon fontSet="material-icons-outlined">email</mat-icon>
                <div class="info-content">
                  <span class="info-label">Purchaser Email</span>
                  <span class="info-value">{{
                    voucherDetails.purchaser.email
                  }}</span>
                </div>
              </div>

              <!-- Recipient Information (only shown if voucher was gifted) -->
              <div class="info-row" *ngIf="voucherDetails?.recipient?.name">
                <mat-icon fontSet="material-icons-outlined"
                  >card_giftcard</mat-icon
                >
                <div class="info-content">
                  <span class="info-label">Gift Recipient</span>
                  <span class="info-value">{{
                    voucherDetails.recipient.name +
                      (voucherDetails.recipient.email
                        ? " (" + voucherDetails.recipient.email + ")"
                        : "")
                  }}</span>
                </div>
              </div>

              <div class="info-row" *ngIf="voucherDetails?.giftMessage">
                <mat-icon fontSet="material-icons-outlined">message</mat-icon>
                <div class="info-content">
                  <span class="info-label">Gift Message</span>
                  <span class="info-value">{{
                    voucherDetails.giftMessage
                  }}</span>
                </div>
              </div>

              <div class="info-row">
                <mat-icon fontSet="material-icons-outlined">event</mat-icon>
                <div class="info-content">
                  <span class="info-label">Expiry</span>
                  <div style="display: flex; align-items: center; gap: 8px">
                    <span
                      class="info-value"
                      *ngIf="!editingExpiry && voucherDetails.expiry"
                      >{{
                        voucherDetails.expiry | date: constants.longDate
                      }}</span
                    >
                    <span
                      class="info-value"
                      *ngIf="!editingExpiry && !voucherDetails.expiry"
                      >This voucher does not expire</span
                    >
                    <input
                      *ngIf="editingExpiry"
                      type="date"
                      class="expiry-date-input"
                      [value]="getExpiryDateValue()"
                      (change)="onExpiryDateChange($event)"
                      [min]="getMinDate()"
                    />
                    <mat-icon
                      *ngIf="!editingExpiry"
                      fontSet="material-icons-outlined"
                      class="edit-icon"
                      (click)="startEditingExpiry()"
                      matTooltip="Edit expiry date"
                      >edit</mat-icon
                    >
                    <mat-icon
                      *ngIf="editingExpiry"
                      fontSet="material-icons-outlined"
                      class="save-icon"
                      (click)="saveExpiryDate()"
                      matTooltip="Save"
                      >check</mat-icon
                    >
                    <mat-icon
                      *ngIf="editingExpiry"
                      fontSet="material-icons-outlined"
                      class="cancel-icon"
                      (click)="cancelEditingExpiry()"
                      matTooltip="Cancel"
                      >close</mat-icon
                    >
                  </div>
                </div>
              </div>

              <div class="info-row" *ngIf="fullRedemption">
                <mat-icon fontSet="material-icons-outlined"
                  >check_circle</mat-icon
                >
                <div class="info-content">
                  <span class="info-label">Redeemed</span>
                  <span class="info-value">{{
                    fullRedemption.date | date: constants.longDate
                  }}</span>
                </div>
              </div>

              <div
                class="info-row"
                *ngIf="voucherDetails?.allowPartialRedemption"
              >
                <mat-icon fontSet="material-icons-outlined"
                  >check_circle</mat-icon
                >
                <div class="info-content">
                  <span class="info-value"
                    >Partial redemption <b>allowed</b></span
                  >
                </div>
              </div>

              <div
                class="info-row"
                *ngIf="!voucherDetails?.allowPartialRedemption"
              >
                <mat-icon fontSet="material-icons-outlined">cancel</mat-icon>
                <div class="info-content">
                  <span class="info-value"
                    >Partial redemption <b>not allowed</b></span
                  >
                </div>
              </div>

              <div
                class="info-row"
                *ngIf="
                  (voucherDetails?.voucher?.[0] ?? voucherDetails.voucher)
                    ?.terms
                "
              >
                <mat-expansion-panel class="terms-panel">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <div class="terms-header">
                        <mat-icon fontSet="material-icons-outlined"
                          >description</mat-icon
                        >
                        <span>Terms & Conditions</span>
                      </div>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <div
                    class="terms-content"
                    [innerHTML]="
                      (voucherDetails?.voucher?.[0] ?? voucherDetails.voucher)
                        ?.terms | linkify
                    "
                  ></div>
                </mat-expansion-panel>
              </div>
            </div>
          </div>
        </div>
      </mat-tab>

      <mat-tab label="Activity">
        <div class="activity-container">
          <div class="activity-timeline">
            <!-- Redemption activities -->
            <div
              class="activity-item"
              *ngFor="
                let redemption of voucherDetails.redemptions.slice().reverse()
              "
            >
              <div class="activity-icon">
                <mat-icon fontSet="material-icons-outlined">receipt</mat-icon>
              </div>
              <div class="activity-content">
                <div class="activity-title">
                  {{
                    redemption.type === "full"
                      ? "Full Redemption"
                      : "Partial Redemption"
                  }}
                </div>
                <div class="activity-details">
                  Amount: {{ redemption.amount | currency: "GBP" }}
                </div>
                <div class="activity-date">
                  {{ redemption.date | date: constants.longDate }}
                </div>
              </div>
            </div>

            <!-- Purchase activity (always last chronologically) -->
            <div class="activity-item">
              <div class="activity-icon">
                <mat-icon fontSet="material-icons-outlined"
                  >shopping_cart</mat-icon
                >
              </div>
              <div class="activity-content">
                <div class="activity-title">
                  {{
                    voucherDetails?.source == "merchant_issued"
                      ? "Voucher Issued"
                      : "Voucher Purchased"
                  }}
                </div>
                <div class="activity-details">
                  Value: {{ voucherDetails.value | currency: "GBP" }}
                </div>
                <div
                  class="activity-details"
                  *ngIf="voucherDetails?.source !== 'merchant_issued'"
                >
                  Origin:
                  {{ voucherDetails?.source == "web" ? "Web" : "App" }}
                </div>

                <div class="activity-date">
                  {{ voucherDetails.createdAt | date: constants.longDate }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </mat-tab>

      <mat-tab label="Joint Holders">
        <div class="assigned-customers-container" style="padding-top: 20px">
          <div
            *ngIf="customersLoading"
            style="text-align: center; padding: 40px"
          >
            <mat-spinner diameter="40" style="margin: 0 auto"></mat-spinner>
            <p style="margin-top: 16px; color: var(--app-grey)">
              Loading customers...
            </p>
          </div>

          <div *ngIf="!customersLoading">
            <!-- Add Customer Section -->
            <div class="add-customer-section" style="margin-bottom: 24px">
              <div style="display: flex; gap: 12px; align-items: center">
                <div style="flex: 1">
                  <single-select
                    label="Select joint holders"
                    [formCtrl]="customerSearchControl"
                    [options]="availableCustomers"
                    property="name"
                    [inBrackets]="'email'"
                    [showSearch]="true"
                  ></single-select>
                </div>

                <app-primary-button
                  [title]="'Assign'"
                  [disabled]="!customerSearchControl.value || assigningCustomer"
                  (tapped)="
                    customerSearchControl.value &&
                      assignCustomer(customerSearchControl.value)
                  "
                  style="margin-top: 8px"
                ></app-primary-button>
              </div>
            </div>

            <!-- Assigned Customers List -->
            <div class="assigned-customers-list">
              <div
                *ngIf="assignedCustomers.length === 0"
                style="
                  text-align: center;
                  padding: 40px 20px;
                  background: var(--app-background);
                  border-radius: 8px;
                "
              >
                <mat-icon
                  style="
                    font-size: 48px;
                    width: 48px;
                    height: 48px;
                    color: var(--app-light-grey);
                    margin-bottom: 12px;
                  "
                  >people_outline</mat-icon
                >
                <p style="color: var(--app-grey); margin: 0">
                  No joint holders assigned yet
                </p>
                <p
                  style="
                    color: var(--app-light-grey);
                    font-size: 14px;
                    margin: 8px 0 0 0;
                  "
                >
                  Assign joint holders above to share this voucher, the voucher
                  will be usable by all assigned joint holders.
                </p>
              </div>

              <div
                *ngIf="assignedCustomers.length > 0"
                style="display: flex; flex-direction: column; gap: 8px"
              >
                <div
                  *ngFor="let customer of assignedCustomers"
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 12px 16px;
                    background: var(--app-background);
                    border-radius: 8px;
                    border: 1px solid var(--app-light-grey);
                  "
                >
                  <div style="display: flex; align-items: center; gap: 12px">
                    <div>
                      <div style="font-weight: 500">{{ customer.name }}</div>
                      <div
                        *ngIf="customer.email"
                        style="font-size: 12px; color: var(--app-grey)"
                      >
                        {{ customer.email }}
                      </div>
                    </div>
                  </div>
                  <button
                    mat-icon-button
                    (click)="unassignCustomer(customer)"
                    [disabled]="assigningCustomer"
                    matTooltip="Remove customer"
                  >
                    <mat-icon style="color: var(--app-error)">close</mat-icon>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>

<div mat-dialog-actions align="end">
  <app-secondary-button
    *ngIf="!voucherDetails"
    [title]="'Cancel'"
    [disabled]="searching"
    (tapped)="matDialogRef.close()"
  ></app-secondary-button>

  <app-secondary-button
    *ngIf="voucherDetails"
    [title]="data?.voucherDetails ? 'Close' : 'Back'"
    [disabled]="redeeming"
    (tapped)="data?.voucherDetails ? matDialogRef.close() : resetSearch()"
    style="margin-right: 10px"
  ></app-secondary-button>

  <app-secondary-button
    *ngIf="voucherDetails"
    [title]="'Download PDF'"
    [disabled]="downloadingPDF || redeeming || sendingEmail"
    (tapped)="downloadVoucherPDF()"
    style="margin-right: 10px"
  ></app-secondary-button>

  <app-secondary-button
    *ngIf="voucherDetails && hasRecipientEmail"
    [title]="'Send Email'"
    [disabled]="sendingEmail || redeeming || downloadingPDF"
    (tapped)="sendVoucherEmail()"
    style="margin-right: 10px"
  ></app-secondary-button>

  <app-primary-button
    *ngIf="validStatus"
    [title]="'Redeem'"
    [disabled]="redeeming || sendingEmail || downloadingPDF"
    (tapped)="redeemVoucher()"
    bgColor="var(--app-timber)"
    color="white"
  ></app-primary-button>
</div>

<loader
  [loading]="searching || redeeming || sendingEmail || downloadingPDF"
></loader>
